export { default as get } from './get';
export { default as update } from './update';
export { default as add } from './add';



// WEBPACK FOOTER //
// ./src/services/api/admin/profiles/index.ts